<template>
<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" class="search" placeholder="Search" v-model="filters.search_term" @search="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">

		<div v-if="!showDetail">
			<div class="label-group">
				<label>Start</label>
				<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')">
			</div>
			<div class="label-group">
				<label>End</label>
				<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')">
			</div>
			<div class="label-group">
				<label></label>
				<div class="button small neutral" @click="getList()">Filter Dates</div>
			</div>

			<div v-if="getAdministratorFlag">
				<label>Client</label>
				<select v-model="filters.client_id" @change="getList()">
					<option value="">Select...</option>
					<option v-for="(client, index) in clientList" :key="index" :value="client.client_id">{{ client.company_name }}</option>
				</select>

				<label>Processor</label>
				<select v-model="filters.payment_processor_id" @change="getList()">
					<option value="">Select...</option>
					<option value="1">Celero</option>
					<option value="9">Electronic Transfer</option>
				</select>
			</div>

			<div class="divider"></div>
			<button class="button neutral" @click="clearFilters()">Clear Filters</button>
		</div>
		<div v-else>
			<button class="button neutral" @click="backToList()">Back To List</button>
		</div>

	</div>

	<div v-if="!showDetail" class="list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Date / Time</th>
					<th v-if="getAdministratorFlag" class="list">Client</th>
					<th v-if="getAdministratorFlag" class="list">Proc</th>
					<th class="list">Register</th>
					<th class="list">User</th>
					<th class="list">IP Address</th>
					<th class="list">Terminal</th>
					<th class="list">Mod</th>
					<th class="list">Resp</th>
					<th class="list">HTTP</th>
				</tr>
			</thead>
			<tr v-for="(log, index) in list" class="clickable-list-item" @click="getDetail(log)">
				<td class="list">{{ log.log_time }}</td>
				<td v-if="getAdministratorFlag" class="list">{{ log.company_name }}</td>
				<td v-if="getAdministratorFlag" class="list">{{ log.processor }}</td>
				<td class="list">{{ log.device_nickname || log.device_license_id }}</td>
				<td class="list">{{ log.user_name }}</td>
				<td class="list">{{ log.ip_address }}</td>
				<td class="list">{{ log.terminal_id }}</td>
				<td class="list">{{ log.terminal_model }}</td>
				<td class="list">{{ log.response_code }}</td>
				<td class="list">{{ log.http_code }}</td>
			</tr>
		</table>

	</div>

	<div v-if="showDetail" class="detail">
		<div class="two-columns">
			<div>
				<label>Date / Time</label>
				<input type="text" v-model="detail.log_time" readonly>
				<label>Processor</label>
				<input type="text" v-model="detail.processor" readonly>
				<label>Register</label>
				<input type="text" :value="detail.device_nickname || detail.device_license_id" readonly>
				<label>User</label>
				<input type="text" v-model="detail.user_name" readonly>
				<label>IP Address</label>
				<input type="text" v-model="detail.ip_address" readonly>
				<label>Terminal</label>
				<input type="text" v-model="detail.terminal_id" readonly>
				<label>Model</label>
				<input type="text" v-model="detail.terminal_model" readonly>
				<label>Response Code</label>
				<input type="text" v-model="detail.response_code" readonly>
				<label>HTTP Code</label>
				<input type="text" v-model="detail.http_code" readonly>
			</div>
			<div>
				<label>Message</label>
				<textarea style="resize: none; height: 19em; margin: 0 0 1em 0;" readonly>{{ detail.message }}</textarea>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

</div>
</template>

<script>
export default {
	name: 'terminal-error-log',
	data() {
		return {
            loading: false,
			message: '',
			messageStatus: '',
			messageTimeout: 0,
			page: 1,
			showPagination: false,
			clientId: '',
			filters: {},
			clientList: [],
			list: [],
			paging: {},
			showDetail: false,
			detail: {}
		}
	},
    created() {
		this.clearFilters()
    },
	methods: {
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList()
		},
		getList() {
			if (this.loading) { return }
            this.loading = true
			this.message = 'Loading terminal error log...'
			this.messageStatus = 'waiting'
			this.showDetail = false
			this.detailChanged = false
			this.apiCall({ destination: 'get_list_terminal_error_log', data: this.filters }).then(obj => {
                this.loading = false
				this.messageStatus = obj.status
				this.message = ''
				this.list = obj.list
				this.paging = obj.paging
				this.clientId = obj.client_id
				this.showPagination = true
				if (obj.clients) {
					this.clientList = obj.clients
				}
			}).catch(err => {
                this.loading = false
				console.log(err)
			})
		},
		getDetail(terminalErrorLog) {
			this.showPagination = false
			this.detail = terminalErrorLog
			this.showDetail = true
		},
		backToList() {
			this.showDetail = false
			this.detail = {}
			this.showPagination = true
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		hasFilters() {
			for (var property in this.filters) {
				if (property != 'page' && this.filters[property] != '') {
					return true
				}
			}
			return false
		},
		clearFilters() {
			let filterType = this.$route.query.type || 'supplier'
			this.filters = {
				page: 1,
				search_term: '',
				start_date: '',
				end_date: '',
                payment_processor_id: '',
                client_id: ''
			}
			var oneMonthAgo = new Date()
			oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
			this.filters.start_date = oneMonthAgo.toISOString().slice(0,10)
			this.filters.end_date = new Date().toISOString().slice(0,10)
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
